<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList">
      <template slot="self-config">
        <el-form-item>
          <el-button type="primary" @click="showCudConfig">连贯操作</el-button>
        </el-form-item>
      </template>
    </common-config>
    <cud-config
      ref="cudConfig"
      :modelId="modelId"
      :cudConfig="form.cud_config"
      @setCudConfig="setCudConfig">
    </cud-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  import cudConfig from '../../../Common/business/cudConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: -1,
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          has_condition: 0, // 是否有条件限制
          condition: {    // 可见条件
            visible: [],  // 可见
            invisible: [],  // 不可见
            forbiden: []  // 禁用
          },
          cud_config: []  // cud配置
        },
        deleteShow: false,  // 删除分组提示显示标识
        inputList: []  // 控件数组
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.has_condition = res.data.config.has_condition
              if (res.data.config.condition) {
                this.form.condition = res.data.config.condition
              }
              if (res.data.config.cud_config) {
                this.form.cud_config = res.data.config.cud_config
              }
            }
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      getInputList() {  // 获取控件列表
        this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            this.inputList = res.data
          }
        })
      },
      showCudConfig() {
        this.$refs.cudConfig.openDialog()
      },
      setCudConfig(config) {
        this.form.cud_config = config
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
    },
    components: {
      commonConfig,
      cudConfig
    },
    mixins: [http, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// deleteConfig.vue?7a4c8bc4